/*
 * 생년월일 포맷터. 구 String.prototype.birthString / birth6String 대체.
 */

/** 구 birthString — 6/8자리를 하이픈 포맷으로, 그 외는 그대로 */
export const formatBirth = (value: string | null | undefined): string | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }
  const raw = String(value)
  if (raw.length === 6) {
    return raw.replace(/(\d{2})(\d{2})(\d{2})/, '$1-$2-$3')
  }
  if (raw.length === 8) {
    return raw.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
  }
  return raw
}

/** 구 birth6String — 8자리(YYYYMMDD)/13자리(주민번호)를 6자리(YYMMDD)로, 그 외는 '-' */
export const toBirth6String = (value: string | null | undefined): string | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }
  const raw = String(value)
  if (raw.length === 8) {
    return raw.substring(2, 8)
  }
  if (raw.length === 6) {
    return raw
  }
  if (raw.length === 13) {
    return raw.substring(0, 6)
  }
  return '-'
}
